package org.hs_soft.runmynesto.pages.home.sub_page.options.component.tabs.operation

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.AlignItems
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.foundation.layout.Spacer
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.silk.components.text.SpanText
import org.hs_soft.runmynesto.domain.config.*

import org.hs_soft.runmynesto.domain.model.general.WindowSizeModeEnum
import org.hs_soft.runmynesto.domain.model.home.options.CountriesEnum
import org.hs_soft.runmynesto.domain.model.home.options.LanguageEnum
import org.hs_soft.runmynesto.domain.model.home.options.operation.option_model.OptionModel
import org.hs_soft.runmynesto.domain.util.ApiUtils
import org.hs_soft.runmynesto.domain.util.Constants
import org.hs_soft.runmynesto.domain.util.helper.Strings
import org.hs_soft.runmynesto.pages.components.CustomEditText
import org.hs_soft.runmynesto.pages.components.DropDownItem
import org.hs_soft.runmynesto.pages.components.MediumContentTitle
import org.jetbrains.compose.web.css.DisplayStyle
import org.jetbrains.compose.web.css.LineStyle


@Composable
fun OptionOperationTab(
    windowSizeMode: WindowSizeModeEnum,
    optionModel: OptionModel?,
    onChangeDataOption: (String, dynamic) -> Unit,
) {


    Column(
        Modifier
            .fillMaxWidth()
            .fillMaxHeight()
            .padding(
                bottom =  Dimen.extraLargePadding,
                top = Dimen.largePadding,
                leftRight = Dimen.extraLargePadding
            )
            .borderRadius(Dimen.semiLargeRadius)
            .border(
                width = Dimen.smallThickness,
                style = LineStyle.Solid,
                color = Theme.ActionDisabledBackground.rgb
            ),
    ) {
        OperationContent(
            optionModel = optionModel,
            onChangeDataOption = {title: String, value: dynamic ->
                onChangeDataOption(title, value)
            },
        )
    }


}

@Composable
private fun OperationContent(
    optionModel: OptionModel?,
    onChangeDataOption: (String, dynamic) -> Unit,
) {
   MediumContentTitle(
        title = Strings.current().operation,
        marginBottom = Dimen.mediumPadding,
    )

    Row(
        modifier = Modifier,
        verticalAlignment = Alignment.CenterVertically
    ) {
        CustomEditText(
            modifier = Modifier,
            label = Strings.current().companyName,
            value = optionModel?.name ?: "",
            hint = "",
            isRequired = true,
            isOutlinedEditText = true,
            onFocusIn = {},
            onFocusOut = { onChangeDataOption(ApiUtils.Field.name, it) },
            onInputChange = { it, validation -> }
        )
        if (optionModel?.name?.isEmpty() == true) {
            SpanText(
                text = Strings.current().companyNameEmptyHint,
                modifier = Modifier
                    .padding(
                        leftRight = Dimen.normalPadding,
                        topBottom = Dimen.smallPadding,
                    )
                    .height(Dimen.menuTooltipHeight)
                    .fontWeight(FontWeight.Medium)
                    .borderRadius(Dimen.lowBorderRadius)
                    .fontFamily(FontFamily.Jakarta)
                    .zIndex(Constants.ZIndex.largeZIndex)
                    .fontSize(FontSizes.normalFontSize)
                    .backgroundColor(Theme.Tooltip.rgb)
                    .color(Theme.White.rgb)
                    .lineHeight(FontLineHeight.lineNormal)
                    .textAlign(TextAlign.Center)
                    .display(DisplayStyle.Flex)
                    .alignItems(AlignItems.Center)
                    .margin(left = Dimen.normalPadding)
            )
        }
    }

    CustomEditText(
        modifier = Modifier,
        label =  Strings.current().street,
        value = optionModel?.street?:"",
        hint = "",
        isOutlinedEditText = true,

        onFocusIn = {

        },
        onFocusOut = {
            onChangeDataOption(ApiUtils.Field.street, it)
        },
        onInputChange = {it, validation ->

        },
    )

    Row(
        modifier =Modifier
            .width(Dimen.semiLargeEditTextWidth)
    )
    {
        CustomEditText(
            modifier = Modifier,
            width = Dimen.smallEditTextWidth,
            label =  Strings.current().zip,
            value = optionModel?.postCode?:"",
            hint = "",
            isOutlinedEditText = true,
            onFocusIn = {

            },
            onFocusOut = {
                onChangeDataOption(ApiUtils.Field.postCode, it)
            },
            onInputChange = {it, validation ->

            },
        )

        Spacer()

        CustomEditText(
            modifier = Modifier,
            width = Dimen.semiMediumEditTextWidth,
            label =  Strings.current().city,
            value = optionModel?.city?:"",
            hint = "",
            isOutlinedEditText = true,
            onFocusIn = {

            },
            onFocusOut = {
                onChangeDataOption(ApiUtils.Field.city, it)
            },
            onInputChange = {it, validation ->

            },
        )
    }

    DropDownItem(
        modifier = Modifier,
        options = LanguageEnum.entries,
        label =  Strings.current().language,
        itemWidth = Dimen.semiLargeEditTextWidth,
        selectedItem = LanguageEnum.fromDisplayName(optionModel?.language?:""),
        displayText = {
            it.toString()
        },
        onOptionClick = {
            if (it is LanguageEnum)
                onChangeDataOption(ApiUtils.Field.language, it.name)
        },
    )


    DropDownItem(
        modifier = Modifier
            .margin(topBottom = Dimen.largePadding),
        options = CountriesEnum.entries,
        itemWidth = Dimen.semiLargeEditTextWidth,
        label =  Strings.current().companyProfile,
        selectedItem = CountriesEnum.entries.find {
            it.id == optionModel?.countryId
        },
        displayText = {
            it.toString()
        },
        onOptionClick = {
            if (it is CountriesEnum){
                onChangeDataOption(ApiUtils.Field.countryId, it.id)
            }

        },
    )




}

